import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => {
  // Drawer styling
  const drawerWidthClose = '63px'; // #genai old nav rail width (keep in sync with MfContainer + privateRoute)

  // Default styling
  const iconButtonDefaultPadding = theme.spacing(1.5);

  // custom styling
  const iconSize = theme.spacing(3);
  const leftPaddingApps = theme.spacing(2);
  const chevronIconBottomPadding = theme.spacing(2);
  const listItemHeight = theme.spacing(7);
  const iconTextspacing = theme.spacing(2);
  const listItemHoverColor = theme.primaryNavigation.appHoverBackgroundColor;
  const listItemSelectedColor = theme.primaryNavigation.appSelectedBGColor;
  const listItemSelectedHoverColor = theme.primaryNavigation.appSelectedHoverColor;
  const iconDefaultColor = theme.primaryNavigation.appIconDefaultColor;
  return {
    drawer: {
      visibility: (props) => (props.show ? 'visible' : 'hidden'),
      opacity: (props) => (props.show ? 1 : 0),
      transition: `all .2s ${theme.transitions.easing.easeInOut}`,
      overflowY: 'hidden',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      backgroundColor: theme.primaryNavigation.color,
    },
    drawerOpen: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: drawerWidthClose,
    },
    drawerHandlerButton: {
      position: 'absolute',
      bottom: chevronIconBottomPadding - iconButtonDefaultPadding,
    },
    // #genai expanded: align with app labels; collapsed: center in rail (63px)
    drawerHandlerButtonOpen: {
      paddingLeft: leftPaddingApps - iconButtonDefaultPadding,
    },
    drawerHandlerButtonCollapsed: {
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: 0,
    },
    notificationsButton: {
      position: 'absolute',
      bottom: iconSize + chevronIconBottomPadding,
    },
    notificationsButtonOpen: {
      paddingLeft: leftPaddingApps - iconButtonDefaultPadding,
    },
    notificationsButtonCollapsed: {
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      paddingLeft: 0,
    },
    removeListPadding: {
      marginTop: theme.spacing(5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
    },
    listStylesBase: {
      paddingTop: (listItemHeight - iconSize) / 2,
      paddingBottom: (listItemHeight - iconSize) / 2,
      '&:hover': {
        backgroundColor: listItemHoverColor,
      },
    },
    listRowOpen: {
      paddingLeft: leftPaddingApps,
      justifyContent: 'flex-start',
    },
    // #genai collapsed rail: center app icons in 63px (ListItemIcon default 56px was tuned for old 56px rail)
    listRowCollapsed: {
      width: '100%',
      boxSizing: 'border-box',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      justifyContent: 'center',
    },
    selectedAppStyle: {
      backgroundColor: listItemSelectedColor,
      '&:hover': {
        backgroundColor: listItemSelectedHoverColor,
      },
    },
    listItemIcon: {
      minWidth: iconSize,
      // MUI defaults ListItemIcon to 56px — breaks centering when rail is 63px
      '&.MuiListItemIcon-root': {
        minWidth: iconSize,
      },
    },
    listItemText: {
      marginLeft: iconTextspacing,
      marginTop: '0',
      marginBottom: '0',
      color: theme.palette.common.white,
    },
    appIcon: {
      width: iconSize,
      height: iconSize,
      fill: iconDefaultColor,
    },
    appIconSelected: {
      fill: theme.palette.common.white,
    },
    chevronIcon: {
      width: iconSize,
      height: iconSize,
      color: iconDefaultColor,
    },
    logoContent: {
      padding: '40px 0',
      boxSizing: 'border-box',
      width: '100%',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    listContent: {
      width: '100%',
      marginTop: theme.spacing(2),
      overflowY: 'overlay',
      maxHeight: '84vh',
      marginBottom: theme.spacing(14),
    },
    logo: {
      width: '40px',
      display: 'block',
      margin: '0 auto',
      padding: 0,
      verticalAlign: 'top',
    },
    logoWithText: {
      width: '256px',
      display: 'block',
      margin: '0 auto',
      padding: 0,
      verticalAlign: 'top',
    },
    evoneButton: {
      '&&': {
        width: theme.typography.pxToRem(64),
        maxWidth: '100%',
        minWidth: 0,
        height: theme.typography.pxToRem(28),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: `${theme.typography.pxToRem(30)} auto 0`,
        padding: 0,
        border: 0,
        borderRadius: 0,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        cursor: 'pointer',
        lineHeight: 0,
      },
      '&&:hover': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
    },
    // #genai expanded drawer: fluid width tracks sidebar, height scales with SVG's 256:56 aspect
    evoneButtonOpen: {
      '&&': {
        width: '100%',
        height: 'auto',
        aspectRatio: '256 / 56',
      },
    },
    evoneButtonImage: {
      width: '100%',
      height: '100%',
      display: 'block',
    },
  };
});
